import React, { Component } from "react";
import AuthService from "../../../components/AuthService";
import ReactPaginate from "react-paginate";
import { Row, Col, Card, CardHeader, CardBody, Table } from "reactstrap";
import { List } from "react-content-loader";

const MyListLoader = () => <List />;

export class DataList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let dataList;
    dataList = this.props.data.map(function(data, index) {
      return (
        <tr key={data.title}>
          <td>{data.title}</td>
          <td>{data.numberOfAnswers}</td>
          <td>{data.score}</td>
        </tr>
      );
    });

    return (
      <Table responsive striped>
        <thead>
          <tr>
            <th>{this.props.dataType}</th>
            <th>Nombre de réponses</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>{dataList}</tbody>
      </Table>
    );
  }
}

class Tables extends Component {
  constructor(props) {
    super(props);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.Auth = new AuthService();
    this.state = {
      data: [],
      offset: 0,
      isLoading: false
    };
  }

  componentDidMount() {
    this.fetchResultsByQuestion(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.newFetch !== this.props.newFetch) {
      this.fetchResultsByQuestion(this);
      this.forceUpdate();
    }
  }

  getTagsRequest(request) {
    var res = "";
    if (window.selectedTags) {
      if (request === "tables") {
        window.selectedTags.forEach(tag => {
          res = res + "&tags[]=" + tag;
        });
      } else {
        window.selectedTags.forEach(tag => {
          res.length
            ? (res = res + "&tags[]=" + tag)
            : (res = res + "?tags[]=" + tag);
        });
      }
    }

    //  si on a bien les dates de selectionnées, on les ajoute à la requete
    if (window.startDateMysql) {
        if(request === "tables") {
            res = res + "&startDate=" + window.startDateMysql
        }else{
            if(res != "")
                res = res + "&startDate=" + window.startDateMysql;
            else
                res = res + "?startDate=" + window.startDateMysql;
        }

    }

    //  si on a bien les dates de selectionnées, on les ajoute à la requete
    if(window.endDateMysql) {
        if(request === "tables") {
            res = res + "&endDate=" + window.endDateMysql
        } else {
            if(res != "")
                res = res + "&endDate=" + window.endDateMysql;
            else
                res = res + "?endDate=" + window.endDateMysql;
        }
    }

    return res;
  }

  fetchResultsByQuestion(thus) {
    let url = this.props.id ? "/" + this.props.id : "";
    this.setState({ isLoading: true });
    this.Auth.httpRequest(
      "GET",
      "api/dashboard/tables/" +
        this.props.tableType +
        url +
        "?limit=" +
        this.props.perPage +
        "&offset=" +
        this.state.offset +
        this.getTagsRequest("tables")
    )
      .then(function(datas) {
          //thus.setState({ isLoading: false }
        if (
          !Array.isArray(datas.data) ||
          (Array.isArray(datas.data) && datas.data.length < 1)
        ) {
          thus.setState({ data: [], pageCount: 0, isLoading: false });
          return;
        }
        thus.Auth.httpRequest(
          "GET",
          "api/dashboard/count/" +
            (thus.props.countType != '' && thus.props.countType !== undefined ? thus.props.countType : thus.props.tableType)
            +
            url +
            thus.getTagsRequest("count")
        )
          .then(function(count) {
            if (thus.state.pageCount && thus.state.pageCount != 0) {
              thus.setState({ data: datas.data });
            } else {
              thus.setState({
                data: datas.data,
                pageCount: Math.ceil(count.data[0].count / datas.data.length)
              });
            }
            thus.setState({ isLoading: false });
          })
          .catch(error => thus.setState({ isLoading: false }));
      })
      .catch(error => thus.setState({ isLoading: false }));
  }

  handlePageClick(data) {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.props.perPage);

    this.setState({ offset: offset }, () => {
      this.fetchResultsByQuestion(this);
    });
  }

  render() {
    let content, title, category, loading;
    switch (this.props.tableType) {
      case "resultsByQuestions":
        title = "Résultats par question";
        category = "Questions";
        break;
      case "resultsByThematics":
        title = "Résultats par thématique";
        category = "Thématiques";
        break;
      case "resultsByUniverses":
        title = "Résultats par univers";
        category = "Univers";
        break;
      case "selectCompanies":
        title = "Liste des companies";
        category = "Companies";
      break;
    }

    if (this.state.data.length == 0) {
      content = (
        <CardBody>
          <List />
        </CardBody>
      );
    } else {
      if (this.state.isLoading) {
        loading = (
          <img
            src="/img/loading_icon.gif"
            style={{
              height: "auto",
              width: "auto",
              maxWidth: 70 + "px",
              maxHeight: 70 + "px"
            }}
          />
        );
      }
      content = (
        <CardBody>
          <DataList data={this.state.data} dataType={category} />
          <ReactPaginate
            previousLabel={"Précédent"}
            nextLabel={"Suivant"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={2}
            onPageChange={this.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
          {loading}
        </CardBody>
      );
    }

    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" lg="12">
            <Card id={this.props.tableType}>
              <CardHeader>
                {title}
              </CardHeader>
              {content}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Tables;



// WEBPACK FOOTER //
// ./src/views/Base/Tables/Tables.js